module.exports = __webpack_public_path__ + "static/media/ldi-leaflet.d0556fc2.png";